
import { defineComponent } from 'vue';
import { Icon } from 'vant';

export default defineComponent({
  props: {
    nav: {
      type: String,
    },
    title: {
      type: String,
    },
    time: {
      type: Number,
    },
  },
  components: {
    [Icon.name]: Icon,
  },
  setup(props) {
    console.log(props);
  },
});
